import { render } from "./Popup.vue?vue&type=template&id=ef92a83e&scoped=true&ts=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"

import "./Popup.scss?vue&type=style&index=0&id=ef92a83e&scoped=true&lang=scss"
import "./PopupGlobal.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef92a83e"]])

export default __exports__